var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-recommendations-container"},[(_vm.isVisibleAtPosition)?_vm._t("default",null,null,{ title: _vm.title, items: _vm.items, isLoading: _vm.isLoading }):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }